import {CalendarDate, parseDate} from '@internationalized/date';
import { gcampaign } from './interfaces';



export const getIsoDateToday = (): string => {
    const today = new Date();
    const y = today.getUTCFullYear();

    const m = String(today.getUTCMonth() + 1).padStart(2, '0');
    const d = String(today.getUTCDate()).padStart(2, '0');

    return `${y}-${m}-${d}`;
}

export const getIsoDate7DaysFromToday = (): string => {
    const today      = new Date();
    const futureDate = new Date(today);
    futureDate.setDate(today.getDate() + 7);

    const y = futureDate.getUTCFullYear();

    const m = String(futureDate.getUTCMonth() + 1).padStart(2, '0');
    const d = String(futureDate.getUTCDate()).padStart(2, '0');

    return `${y}-${m}-${d}`;
}


export const toIsoDateStr = (val?: string, fallback?: boolean): string | undefined => {
    if (!val) val = (fallback ? getIsoDateToday() : undefined);
    if (!val) return undefined;

    let d = new Date(val);

    if (isNaN(d.getTime())) d = fallback ? new Date(getIsoDateToday()) : d;
    if (!d) return undefined;

    const y     = d.getUTCFullYear();
    const m     = String(d.getUTCMonth() + 1).padStart(2, '0');
    const day   = String(d.getUTCDate()).padStart(2, '0');

    return `${y}-${m}-${day}`;
};

export const getDateRange = (camp: gcampaign | undefined): { start: CalendarDate, end: CalendarDate } | undefined => {
    const startStr = toIsoDateStr(camp?.campaign_start_date);
    const endStr   = toIsoDateStr(camp?.campaign_end_date);
    const rangeVal = (startStr && endStr) ? { start: parseDate(startStr), end: parseDate(endStr) } : undefined;
    return rangeVal;
}